// extracted by mini-css-extract-plugin
module.exports = {"root":"Container-module__root___OArsQ","root--full-width":"Container-module__root--full-width___J2lS2"};